import type { Types } from '@ohif/core';
import React from 'react';
import SRViewportWrapper from './components/SRViewport';

/**
 * D2. ViewerViewportGrid never passes servicesManager/extensionManager to a
 * registered viewport component, so this closure re-injects them ahead of
 * the {...props} spread -- mirroring cornerstone-dicom-sr's own
 * getViewportModule registration.
 */
export default function getViewportModule({
  servicesManager,
  extensionManager,
}: Types.Extensions.ExtensionParams) {
  const ExtendedSRViewportWrapper = (props: withAppTypes) => (
    <SRViewportWrapper
      servicesManager={servicesManager}
      extensionManager={extensionManager}
      {...props}
    />
  );

  return [{ name: 'dicom-sr', component: ExtendedSRViewportWrapper }];
}
